module.exports = __webpack_public_path__ + "img/pagyongyi.ca8b51da.jpg";